module.exports = __webpack_public_path__ + "resources/images/screen5-f42a95d7c6911eae05512892f75743a0-cache.png";